import { useEffect, useState } from 'react'
import { subscribeMemberOutbox } from '../services/memberOutboxService'

export type MemberOutboxCounts = {
  queued: number
  failed: number
}

export const useMemberOutboxCounts = (): MemberOutboxCounts => {
  const [counts, setCounts] = useState<MemberOutboxCounts>({ queued: 0, failed: 0 })

  useEffect(() => {
    const unsubscribe = subscribeMemberOutbox((snapshot) => {
      setCounts({
        queued: (snapshot.pendingCount ?? 0) + (snapshot.syncingCount ?? 0),
        failed: snapshot.failedIds ? snapshot.failedIds.length : 0,
      })
    })
    return () => {
      unsubscribe()
    }
  }, [])

  return counts
}
